import React, { useState, useEffect } from "react";
import AdminLayout from "./AdminLayout";
import { EnvelopeIcon, InformationCircleIcon } from "@heroicons/react/24/solid";

const SendMarketingEmail = () => {
  const [emails, setEmails] = useState("");
  const [loading, setLoading] = useState(false);
  const [message, setMessage] = useState({ type: "", text: "" });

  useEffect(() => {
    let timeoutId;
    if (message.type === "success") {
      timeoutId = setTimeout(() => {
        setMessage({ type: "", text: "" });
      }, 3000);
    }
    return () => {
      if (timeoutId) {
        clearTimeout(timeoutId);
      }
    };
  }, [message.type]);


  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setMessage({ type: "", text: "" });

    // Convert comma-separated emails to an array and trim spaces
    const emailList = emails
      .split(",")
      .map((email) => email.trim())
      .filter((email) => email.length > 0);

    if (emailList.length === 0) {
      setMessage({
        type: "error",
        text: "Please enter at least one valid email",
      });
      setLoading(false);
      return;
    }

    const emailHtml = `<!DOCTYPE html>
<html>
<head>
    <meta charset="UTF-8">
    <meta name="viewport" content="width=device-width, initial-scale=1">
    <title>Save Big on AVVs – Just $220 Each!</title>
</head>
<body style="font-family: Arial, sans-serif; background-color: #f4f4f4; margin: 0; padding: 0;">
    <div style="max-width: 600px; background: #ffffff; margin: 20px auto; padding: 25px; border-radius: 8px; box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1); text-align: left;">
    
        <!-- Header -->
        <div style="background-color: #000; padding: 14px; border-radius: 8px 8px 0 0; text-align: center;">
            <h1 style="font-size: 18px; font-weight: bold; color: #ffffff; margin: 0; margin-top: 10px;">Save Big on AVVs – Just $220 Each!</h1>
        </div>
    
        <!-- Introduction -->
        <p style="font-size: 16px; color: #333; margin-top: 20px;">Dear Customer,</p>
        <p style="font-size: 15px; color: #555;">We’re excited to offer you a discount on AVVs when you get your <strong>Model Reports</strong> through us!</p>
        <p style="font-size: 15px; color: #555;">✅ Model Report – Your base price</p>
        <p style="font-size: 15px; color: #555;">✅ AVV – Now only $220 (was $330)</p>
        <p style="font-size: 15px; color: #555;">By getting your Model Report and AVV from us, you not only ensure quality and accuracy but also enjoy significant savings.<strong>Secure your AVV at the discounted rate today!</strong></p>

    
        <!-- Benefits Section -->
        <h3 style="color: #1e293b; font-size: 18px;">🌐 Introducing the All-New ShuiMir.com</h3>
        <p style="font-size: 15px; color: #555;">
        Whether you're in compliance, vehicle import, or engineering, Shui Mir is now your all-in-one solution.
        </p>
        <h4 style="color: #1e293b; font-size: 16px;">What's New:</h4>
        <ul style="font-size: 15px; color: #555; padding-left: 20px;">
            <li>✔ About Us – Learn more about Shui Mir and our mission</li>
            <li>✔ Latest Model Reports – Stay up to date with newly approved reports</li>
            <li>✔ Top-Selling Reports – See what's trending</li>
            <li>✔ Transparent Pricing – Know your costs upfront</li>
            <li>✔ All Model Reports – Browse full specs and MRE info</li>
            <li>✔ VIN Verification – Instantly verify your vehicle with a unique ID</li>
            <li>✔ Live SEVS expiry status</li>
            <li>✔ Enquiry Form – Ask us anything directly</li>
            <li>✔ Login Access – Exclusive access to our Model Report Software anytime</li>
        </ul>
        <p style="font-size: 15px; color: #555;">
        Start exploring today and experience the difference at <a href="https://shuimir.com" style="color: #2563eb; text-decoration: none;">ShuiMir.com</a>!
        </p>
    
        <!-- Step-by-Step Guide -->
        <h3 style="color: #1e293b; font-size: 18px;">🔄 New to Our Model Report Software?</h3>
        <p style="font-size: 15px; color: #555;">Here’s how to get started:</p>
        <ul style="font-size: 15px; color: #555; padding-left: 20px;">
            <li>Sign In – Enter email & phone, get OTP</li>
            <li>Verify OTP – Enter the 6-digit code</li>
            <li>Dashboard – View & manage orders</li>
            <li>Select Report – Choose from the list or during form fill</li>
            <li>New Order – Fill in your details and submit</li>
            <li>Track & Pay – Monitor status, get invoices & documents</li>
            <li>Payment:
                <ul style="font-size: 15px; color: #555; padding-left: 20px;">
                    <li>First-time: Wait for verification</li>
                    <li>Next orders: Pay instantly and download documents right away</li>
                </ul>
            </li>
        </ul>
    
        <!-- Call to Action -->
        <div style="text-align: center; margin: 20px 0;">
            <a href="https://www.mdlreports.com.au" style="display: inline-block; background: #2563eb; color: #fff; padding: 12px 24px; text-decoration: none; border-radius: 5px; font-size: 16px;">
                Access Your Portal
            </a>
        </div>

        <!-- Pricing Structure -->
        <h3 style="color: #1e293b; font-size: 18px;">Pricing Structure</h3>
        <p style="font-size: 15px; color: #555;">
            Pricing is tailored based on your Model Report frequency, with different groups and rates to suit your needs. Check out our updated pricing structure below:
        </p>

        <!-- First Table -->
        <table style="width: 100%; border-collapse: collapse; font-size: 15px; margin-top: 10px;">
            <thead>
                <tr style="background-color: #e2e8f0;">
                    <th style="padding: 8px; border: 1px solid #cbd5e0;">S No.</th>
                    <th style="padding: 8px; border: 1px solid #cbd5e0;">Type</th>
                    <th style="padding: 8px; border: 1px solid #cbd5e0;">Price</th>
                </tr>
            </thead>
            <tbody>
                <tr>
                    <td style="padding: 8px; border: 1px solid #cbd5e0;">1</td>
                    <td style="padding: 8px; border: 1px solid #cbd5e0;">Common Vehicle</td>
                    <td style="padding: 8px; border: 1px solid #cbd5e0;">Customer base price (Dependent on monthly purchase quantities).</td>
                </tr>
                <tr>
                    <td style="padding: 8px; border: 1px solid #cbd5e0;">2</td>
                    <td style="padding: 8px; border: 1px solid #cbd5e0;">Unique (MRE only available through Us)</td>
                    <td style="padding: 8px; border: 1px solid #cbd5e0;">Customer Base price + $220</td>
                </tr>
                <tr>
                    <td style="padding: 8px; border: 1px solid #cbd5e0;">3</td>
                    <td style="padding: 8px; border: 1px solid #cbd5e0;">Welcabs Ramps/ Side Seat</td>
                    <td style="padding: 8px; border: 1px solid #cbd5e0;">Customer Base price + $1.10</td>
                </tr>
                <tr>
                    <td style="padding: 8px; border: 1px solid #cbd5e0;">4</td>
                    <td style="padding: 8px; border: 1px solid #cbd5e0;">Campervan</td>
                    <td style="padding: 8px; border: 1px solid #cbd5e0;">Customer Base price + $1.10</td>
                </tr>
                <tr>
                    <td style="padding: 8px; border: 1px solid #cbd5e0;">5</td>
                  <td style="padding: 8px; border: 1px solid #cbd5e0;">Fixed Price</td>
                    <td style="padding: 8px; border: 1px solid #cbd5e0;">Each car is priced individually based on availability</td>
                </tr>
                <tr>
                    <td style="padding: 8px; border: 1px solid #cbd5e0;">6</td>
                    <td style="padding: 8px; border: 1px solid #cbd5e0;">Bikes</td>
                    <td style="padding: 8px; border: 1px solid #cbd5e0;">$550</td>
                </tr>
                <tr>
                    <td style="padding: 8px; border: 1px solid #cbd5e0;">7</td>
                    <td style="padding: 8px; border: 1px solid #cbd5e0;">Trucks</td>
                    <td style="padding: 8px; border: 1px solid #cbd5e0;">$1100</td>
                </tr>
            </tbody>
        </table>

        <!-- Second Table -->
        <table style="width: 100%; border-collapse: collapse; font-size: 15px; margin-top: 20px;">
            <thead>
                <tr style="background-color: #e2e8f0;">
                    <th style="padding: 8px; border: 1px solid #cbd5e0;">S No.</th>
                    <th style="padding: 8px; border: 1px solid #cbd5e0;">No. of MRE (in a Month)</th>
                    <th style="padding: 8px; border: 1px solid #cbd5e0;">Price</th>
                </tr>
            </thead>
            <tbody>
                <tr>
                    <td style="padding: 8px; border: 1px solid #cbd5e0;">1</td>
                    <td style="padding: 8px; border: 1px solid #cbd5e0;"><10</td>
                    <td style="padding: 8px; border: 1px solid #cbd5e0;">$330</td>
                </tr>
                <tr>
                    <td style="padding: 8px; border: 1px solid #cbd5e0;">2</td>
                    <td style="padding: 8px; border: 1px solid #cbd5e0;">10-20</td>
                    <td style="padding: 8px; border: 1px solid #cbd5e0;">$285</td>
                </tr>
                <tr>
                    <td style="padding: 8px; border: 1px solid #cbd5e0;">3</td>
                    <td style="padding: 8px; border: 1px solid #cbd5e0;">20-30</td>
                    <td style="padding: 8px; border: 1px solid #cbd5e0;">$220</td>
                </tr>
                <tr>
                    <td style="padding: 8px; border: 1px solid #cbd5e0;">4</td>
                    <td style="padding: 8px; border: 1px solid #cbd5e0;">30-50</td>
                    <td style="padding: 8px; border: 1px solid #cbd5e0;">$165</td>
                </tr>
                <tr>
                    <td style="padding: 8px; border: 1px solid #cbd5e0;">5</td>
                    <td style="padding: 8px; border: 1px solid #cbd5e0;">50+</td>
                    <td style="padding: 8px; border: 1px solid #cbd5e0;">$110</td>
                </tr>
            </tbody>
        </table>

     

<br>
<br>
<p  style ="margin: 5px 0; font-size: 14px; color: #333; font-weight: bold">Kind regards,</p>
<p  style ="margin: 5px 0; font-size: 14px; color: #333;">Team Grey Imports Australia</p>
    
            <!-- Contact Information -->
            <div style="background-color: #f1f5f9; padding: 20px; margin-top: 30px; border-radius: 8px;">
                <p style="margin: 0; font-weight: bold; font-size: 15px; color: #1e293b;">Need Assistance?</p>
                <p style="margin: 5px 0; font-size: 14px; color: #555;">Contact our support team for any queries.</p>
                <hr style="border: none; border-top: 1px solid #ccc;">
                
                <p style="margin: 5px 0; font-size: 14px; color: #333;"><strong>Phone:</strong> 03 8555 2004</p>
                <p style="margin: 5px 0; font-size: 14px; color: #333;"><strong>Email:</strong> <a href=mailto:modelreports@mdlreports.com.au style="color: #2563eb; text-decoration: none;">modelreports@mdlreports.com.au</a></p>
                <p style="margin: 5px 0; font-size: 14px; color: #333;"><strong>Address:</strong> 26 Havelock Road, Bayswater, VIC 3153</p>
            </div>
    
        </div>
    </body>
    </html>
`;

    try {
      const response = await fetch(
        `${process.env.REACT_APP_SUPABASE_URL}/functions/v1/send-bulk-email`,
        {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({
            emails: emailList, // Send as an array
            message: emailHtml,
            subject: "Get AVVs for $220! + Discover What’s New at ShuiMir.com!",
          }),
        }
      );

      if (!response.ok) {
        throw new Error("Failed to send email");
      }

      setMessage({
        type: "success",
        text: "Marketing email sent successfully to all recipients!",
      });
      setEmails("");
    } catch (error) {
      setMessage({
        type: "error",
        text: error.message || "Failed to send marketing email",
      });
    } finally {
      setLoading(false);
    }
  };

  return (
    <AdminLayout
      activeItemId="send-email"
      title="Send Marketing Email"
      subtitle="Send marketing emails to customers."
      contentClassName="w-full"
    >
      <div className="w-full pb-12">
        <div className="grid items-start gap-6 xl:grid-cols-[minmax(0,1.7fr)_minmax(320px,0.9fr)]">
          <div className="order-2 xl:order-1">
            <div className="overflow-hidden rounded-[2rem] border border-slate-200 bg-white shadow-sm shadow-slate-200/60">
              <div className="px-5 pt-5 pb-3 sm:px-6">
                <h2 className="flex items-center gap-2 text-md font-medium text-gray-800 uppercase tracking-[0.04em]">
                  <EnvelopeIcon className="h-5 w-5 text-blue-600" />
                  Recipient Email Details
                </h2>
              </div>

              <div className="border-t border-slate-200 px-5 py-5 sm:px-6 sm:py-6">
                <form onSubmit={handleSubmit} className="space-y-4">
                  <div>
                    <label className="mb-2 block text-sm font-medium text-slate-700">Recipient Emails</label>
                    <textarea
                      id="emails"
                      name="emails"
                      rows="8"
                      required
                      value={emails}
                      onChange={(e) => setEmails(e.target.value)}
                      placeholder="john@example.com, jane@example.com"
                      className="w-full rounded-[1rem] border border-slate-200 bg-white px-4 py-3 text-sm text-slate-900 shadow-sm outline-none transition focus:border-blue-500 focus:ring-2 focus:ring-blue-100"
                    />
                    <p className="mt-2 text-sm text-slate-500">
                      Separate each email with a comma. Spaces will be trimmed automatically.
                    </p>
                  </div>

                  {message.text && (
                    <div
                      className={`rounded-[1rem] border px-4 py-3 text-sm shadow-sm ${
                        message.type === "success"
                          ? "border-green-200 bg-green-50 text-green-700"
                          : "border-red-200 bg-red-50 text-red-700"
                      }`}
                    >
                      {message.text}
                    </div>
                  )}

                  <button
                    type="submit"
                    disabled={loading}
                    className="inline-flex items-center justify-center rounded-[0.9rem] bg-blue-600 px-4 py-2.5 text-sm font-medium text-white shadow-sm transition-all duration-200 hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-2 disabled:cursor-not-allowed disabled:opacity-70"
                  >
                    {loading ? 'Sending...' : 'Send Email'}
                  </button>
                </form>
              </div>
            </div>
          </div>

          <div className="order-1 xl:order-2">
            <div className="overflow-hidden rounded-[2rem] border border-slate-200 bg-white shadow-sm shadow-slate-200/60">
              <div className="px-5 py-5 sm:px-6 sm:py-6">
                <h2 className="mb-4 flex items-center gap-2 text-md font-medium text-gray-900 uppercase tracking-[0.04em]">
                  <InformationCircleIcon className="h-5 w-5 text-blue-600" />
                  How it works
                </h2>
                <div className="space-y-3 text-sm text-slate-600">
                  <div className="rounded-[1rem] border border-slate-200 bg-slate-50/80 px-4 py-3 shadow-sm">
                    1. Add one or more recipient email addresses (comma-separated).
                  </div>
                  <div className="rounded-[1rem] border border-slate-200 bg-slate-50/80 px-4 py-3 shadow-sm">
                    2. Review the list and make sure the addresses are correct.
                  </div>
                  <div className="rounded-[1rem] border border-slate-200 bg-slate-50/80 px-4 py-3 shadow-sm">
                    3. Click Send Email.
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </AdminLayout>
  );
};

export default SendMarketingEmail;
